import React from 'react'

import { CardHeader, Grid } from '@material-ui/core'
import ActionBar from '../../../../ActionBar/ActionBar'
import { withTranslate } from 'react-redux-multilingual'
import PageInfo from '../../../../PageInfo/PageInfo'

const individualHeader = ({
  filterButtonClicked,
  exportButtonClicked,
  exportButtonDisabled,
  importButtonClicked,
  pageTranslateKey,
  pagePermission,
  translate
}) => {
  let actions = ['filter', 'export']
  if (pagePermission?.is_add) {
    actions = [...actions, 'import']
  }
  return (
    <CardHeader
      title={
        <Grid container justify={'space-between'}>
          <Grid item xs sm>
            <ActionBar
              show={actions}
              filtering={filterButtonClicked}
              exporting={exportButtonClicked}
              exportDisabled={exportButtonDisabled}
              importing={importButtonClicked}
              importDisabled={!pagePermission?.is_view || false}
              leftContent={<PageInfo pageTranslateKey={pageTranslateKey} />}
            />
          </Grid>
        </Grid>
      }
    />
  )
}

export default withTranslate(individualHeader)
